import { createFileRoute } from '@tanstack/react-router'
import { ProjectAccessPage } from '@/features/account/pages/projects/project-access-page'

/**
 * F2 — who has access to this project (share · revoke · transfer · delete).
 *
 * Deliberately NOT the project's canonical URL: `…/projects/$projectId` is the
 * permalink that opens the project itself, and permissions live behind this
 * explicit share affordance. See `project-permalink-page.tsx`.
 */
export const Route = createFileRoute('/_ws/w/$workspaceId/projects/$projectId/access')({
  component: ProjectAccessPage,
})
